import { useState, useCallback } from "react";
import { Combobox, type ComboboxOption } from "@altimateai/lego";
import { useSSOExternalGroups } from "./hooks";

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const GroupIdentifierInput = ({ value, onChange, placeholder }: Props) => {
  const [search, setSearch] = useState("");
  const { data } = useSSOExternalGroups(search || undefined);
  const groups = data?.groups ?? [];

  const options: ComboboxOption[] = groups.map(g => ({
    value: g.group_name,
    label: g.group_name,
  }));

  // Allow free-form input: add typed search text as a selectable option
  if (search && !options.some(o => o.value === search)) {
    options.unshift({ value: search, label: search });
  }

  // Ensure current value appears in list (for edit mode)
  if (value && value !== search && !options.some(o => o.value === value)) {
    options.unshift({ value, label: value });
  }

  const handleLoadMore = useCallback(async (searchValue?: string) => {
    setSearch(searchValue ?? "");
  }, []);

  return (
    <Combobox
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Type to search groups..."
      onLoadMore={handleLoadMore}
      hasMore={false}
      buttonProps={{ className: "al-w-full" }}
    />
  );
};
